// Genuine Google Business Profile Data for ActiveRehab Clinic Locations
// Official Source URLs:
// Kondapur: https://maps.app.goo.gl/DreQ38PMATcsxC6w9
// Kompally: https://maps.app.goo.gl/TbH3ZDQ6Yd7uKChs7

export const googleProfiles = {
  kondapur: {
    id: "kondapur",
    name: "ActiveRehab – Kondapur",
    fullName: "ActiveRehab Chiropractic and Physiotherapy Centre Hyderabad",
    rating: 4.8,
    reviewCount: 204,
    mapsUrl: "https://maps.app.goo.gl/DreQ38PMATcsxC6w9",
    address: "Plot No. 1272, 80 Feet Road, above Burfi Ghar, Rajarajeshwara Colony, Kondapur, Telangana 500084",
    phone: "+91 9000229040"
  },
  kompally: {
    id: "kompally",
    name: "ActiveRehab – Kompally",
    fullName: "ActiveRehab Chiropractic and Physiotherapy Centre",
    rating: 4.8,
    reviewCount: 73,
    mapsUrl: "https://maps.app.goo.gl/TbH3ZDQ6Yd7uKChs7",
    address: "Hale Clinics, Survey No. 43, Second Floor, beside Bajaj Electronics, above Manyavar, Suchitra Road, Petbasheerabad, Quthbullapur, Opp. Decathlon, Kompally, Hyderabad, Telangana 500055",
    phone: "+91 9000229040"
  }
};

export const googleReviews = {
  kondapur: [
    {
      id: "kon-1",
      name: "Neha Yadav",
      rating: 5,
      review: "He is the best Chiropractor I have been to. My neck pain, backache, my mother's Frozen shoulder, my son's Plantar fasciitis has all been treated by Dr. Ashok. He listens to your issues very patiently, gives enough time to each patient.",
      date: "Google Review",
      location: "Kondapur",
      sourceUrl: "https://maps.app.goo.gl/DreQ38PMATcsxC6w9",
      avatarBg: "bg-blue-600 text-white"
    },
    {
      id: "kon-2",
      name: "Sameendra Rachuri",
      rating: 5,
      review: "I was suffering from lower back pain and consulted Dr. Ashok Kota regarding this. After a thorough discussion about my condition and a checkup, he suggested two to three chiropractic sessions to relieve my muscle tension and some lower body and neck exercises.",
      date: "Google Review",
      location: "Kondapur",
      sourceUrl: "https://maps.app.goo.gl/DreQ38PMATcsxC6w9",
      avatarBg: "bg-emerald-600 text-white"
    },
    {
      id: "kon-3",
      name: "Kolli Srilaxmi",
      rating: 5,
      review: "I had knee pain and lower back pain. I found Dr. Ashok on Google and went for treatment. Explained all my issues, he listened carefully and explained about the sessions/treatment. My pain cured in 4 sessions. I will recommend my friends as well.",
      date: "Google Review",
      location: "Kondapur",
      sourceUrl: "https://maps.app.goo.gl/DreQ38PMATcsxC6w9",
      avatarBg: "bg-purple-600 text-white"
    },
    {
      id: "kon-4",
      name: "Sachin Gupta",
      rating: 5,
      review: "Dr. Ashok under promises and over delivers. For me he said I might improve but I saw major improvement after 3 sessions. His empathetic nature, precision of how much adjustment is required and confidence in his skills sets him apart!",
      date: "Google Review",
      location: "Kondapur",
      sourceUrl: "https://maps.app.goo.gl/DreQ38PMATcsxC6w9",
      avatarBg: "bg-amber-600 text-white"
    },
    {
      id: "kon-5",
      name: "Mahesh kumar Birru",
      rating: 5,
      review: "I was having a lot of low back pain and stiffness for more than 3 years and I would always feel a heavy weight in my back. Tried so many other treatments before coming to Dr Ashok Kota. Dr Ashok thoroughly examined me and suggested 3 sessions of Chiropractic spinal adjustments. In 3 sessions, my low back pain and stiffness has improved drastically and now I feel very light on my low back. I could walk easily now. Thank you for all the help Dr Kota.",
      date: "3 months ago",
      location: "Kondapur",
      sourceUrl: "https://maps.app.goo.gl/DreQ38PMATcsxC6w9",
      avatarBg: "bg-teal-600 text-white"
    },
    {
      id: "kon-6",
      name: "Shiva Shanker K",
      rating: 5,
      review: "I had a fantastic experience from start to finish. The doctor took the time to truly listen to my concerns. He explained every part of the assessment clearly and provided a personalized care plan that gave me instant relief and hope for long-term recovery. Highly recommended for anyone looking for expert, compassionate care.",
      date: "4 months ago",
      location: "Kondapur",
      sourceUrl: "https://maps.app.goo.gl/DreQ38PMATcsxC6w9",
      avatarBg: "bg-indigo-600 text-white"
    }
  ],
  kompally: [
    {
      id: "kom-1",
      name: "Anant Bansal",
      rating: 5,
      review: "I suffered a lower back injury at the gym and honestly had very little understanding of what was actually going on. Ashok Sir from ActiveRehab understood my situation really well and guided me in the right direction with the right procedures.\n\nAfter just one session, I felt a significant amount of relief, and within a week, I was feeling much better.\n\nWhat I appreciated the most was how genuinely he approached my case. He took the time to understand my situation, educate me about the problem, and after a proper examination …he even discussed whether any treatment was actually required or not. That level of honesty and transparency is rare, especially when compared to practitioners who may just scare you into expensive treatments or medications without fully understanding the situation.\n\nHe truly has magic in his hands, and clearly knows his stuff. If you're a Marvel fan, he's The Doctor Steven Strange you're looking for! 😄\n\nHighly recommended!",
      date: "a month ago",
      location: "Kompally",
      sourceUrl: "https://maps.app.goo.gl/TbH3ZDQ6Yd7uKChs7",
      avatarBg: "bg-blue-600 text-white"
    },
    {
      id: "kom-2",
      name: "Vishal Gorityal",
      rating: 5,
      review: "After 6 weeks of physiotherapy and chiropractic treatment, my stiffness and pain have reduced significantly. What I appreciated most is that the care is both effective and cost effective. The staff is supportive and makes you feel comfortable. Also the premises looks neat and clean. Would definitely recommend!",
      date: "a month ago",
      location: "Kompally",
      sourceUrl: "https://maps.app.goo.gl/TbH3ZDQ6Yd7uKChs7",
      avatarBg: "bg-emerald-600 text-white"
    },
    {
      id: "kom-3",
      name: "alekhya vempati",
      rating: 5,
      review: "I had been suffering from severe back pain for a long time and had consulted several highly experienced doctors, but unfortunately none of the treatments provided lasting relief. The pain was affecting my daily life and it became very frustrating.\n\nAfter visiting Active rehab my experience completely changed. Dr.Ashok carefully listened to my problem, explained the root cause of my back pain, and provided the right treatment with great care and professionalism. Within a short period of time, I started noticing significant improvement, and now my back pain is almost completely gone.\n\nI am truly grateful for the expertise, patience, and dedication shown throughout my treatment. It’s amazing that a problem which many other doctors could not fix was resolved here. I highly recommend Dr Ashok to anyone struggling with back pain or spine-related issues. Thank you so much for giving me relief and improving my quality of life.",
      date: "6 months ago",
      location: "Kompally",
      sourceUrl: "https://maps.app.goo.gl/TbH3ZDQ6Yd7uKChs7",
      avatarBg: "bg-purple-600 text-white"
    },
    {
      id: "kom-4",
      name: "Aditya Naldiga",
      rating: 5,
      review: "I consulted Dr. Ashok P Kota for shoulder, traps, and hamstring stiffness due to intense gym workouts.\n\nHe carefully assessed my condition and identified an acute cervical disc bulge, explaining everything clearly before starting treatment.\n\nThe combination of chiropractic care and advanced physiotherapy worked very well for me. He was patient, attentive, and focused on both recovery and long-term prevention. The physiotherapy team was skilled and ensured each session was done properly, and the reception staff were polite and professional throughout.\n\nHe also guided me with effective mobility and home exercises, which really helped my recovery.\n\nRating: ⭐⭐⭐⭐⭐ (5/5)\n\nHighly recommended for anyone dealing with muscle stiffness or spine-related issues.",
      date: "5 months ago",
      location: "Kompally",
      sourceUrl: "https://maps.app.goo.gl/TbH3ZDQ6Yd7uKChs7",
      avatarBg: "bg-amber-600 text-white"
    },
    {
      id: "kom-5",
      name: "pandu sonti",
      rating: 5,
      review: "I was experiencing severe muscle pain in the back of my shoulder, which gradually spread down to my lower arm. The pain was intense and even affected my sleep at night. Painkiller tablets did not provide any relief.\nFinally, I consulted Dr. Ashok for physiotherapy. His diagnosis and treatment were very effective, and the therapy sessions helped me recover completely. I’m truly grateful for his care and professionalism. I highly recommend him to anyone facing similar issues.",
      date: "4 months ago",
      location: "Kompally",
      sourceUrl: "https://maps.app.goo.gl/TbH3ZDQ6Yd7uKChs7",
      avatarBg: "bg-teal-600 text-white"
    },
    {
      id: "kom-6",
      name: "Merlyn Miranda",
      rating: 5,
      review: "Have been suffering from neck pain and upper back pain for more than 3 months. After coming to Dr Ashok at ActiveRehab Chiropractic Centre, my pain improved in 5 sessions and has been advised doing some exercises which should help more.\nI recommend Dr Ashok for any one suffering from neck pain, back pain or sciatica.\nThank you.",
      date: "3 months ago",
      location: "Kompally",
      sourceUrl: "https://maps.app.goo.gl/TbH3ZDQ6Yd7uKChs7",
      avatarBg: "bg-indigo-600 text-white"
    }
  ]
};
